import type { Campaign, Task } from '../types'

export function taskMatchesOperation(task: Task, campaigns: Campaign[], operation: string) {
  const campaign = campaigns.find(item => item.id === task.campaignId)
  if (operation === 'Todas as operações') return true
  if (operation === 'Hub Sudeste') return campaign?.clientId === 'assai'
  return campaign?.operation === operation
}
